// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import { addGlobalFilter, resetGlobalFilter } from './_locationsCatalog';
import $ from 'jquery';
import {
  deleteQueryVar,
  getQuerVariables,
  getQueryVar,
  setQueryVar,
} from '../_util';
import common from './_common';
import { pushTrackerEvent } from '../_googleTagManager';
import {
  get as _get,
} from 'lodash-es';
import Popover from 'bootstrap/js/dist/popover';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'contact';
// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class contactForm {
  constructor(el) {
    this.el = el;

    this.stepAmount = $(el).find('.contact__step').length;
    this.stepCounter = 1;
    this.stepData = {};
    this.stepLabels = {};

    const self = this;

    $(this.el).find('.contact__step-result input, .contact__step-result button').click(function () {
      const parentStepWrapper = $(this).closest('.contact__step');
      const stepNumber = self.getStepNumberInClasses(parentStepWrapper.attr('class').split(/\s+/));

      self.showStep(stepNumber ? stepNumber : 1, '', {});
    });

    $(this.el).find('[data-step-next]').click(function (e) {
      e.preventDefault();
      if (e.target.className.includes('button-info') || e.target.className.includes('fa')) {

        const btnInfo = $('.btn--info');
        const allPopovers = $('.popover');
        const popoverElement = this.querySelector('.button-info');
        const currentLabel = this.closest('[data-step-label]').getAttribute('data-step-label').replaceAll(' ', '-');
        const popoverId = this.querySelector('[data-popover-id]').getAttribute('data-popover-id').replaceAll(' ', '-');
        let popover;

        btnInfo.blur();

        if ($(this).hasClass('active')) {
          btnInfo.removeClass('active');
          allPopovers.fadeOut();
          return;
        } else {
          $(this).addClass('active');
        }

        allPopovers.fadeOut();
        if (document.querySelector(`.popover.${currentLabel}`)) {
          $(`.popover.${currentLabel}`).show();
        } else {
          popover = new Popover(popoverElement, {
            customClass: currentLabel,
            content: document.querySelector(`#${popoverId}`)
          });
          popover.show();
        }

        // tracking
        const label = $(this).attr('data-step-label');

        pushTrackerEvent('contactInfoPopover', {
          'sector': label,
        });

        popoverElement.addEventListener('shown.bs.popover', function () {
          document.querySelector(`.popover.${currentLabel} a`).addEventListener('click', function (item) {
            const popoverID = item.target.closest('.popover').getAttribute('id');

            btnInfo.removeClass('active');
            $(this).closest('.popover').hide();
            self.clickStepElement($(`[aria-describedby="${popoverID}"]`).closest('.btn--info'));
          });
        })
      } else {
        $('.popover').hide();
        $('.btn--info').removeClass('active');
        self.clickStepElement($(this));
      }
    });

    this.attachContactClickEvents();

    this.openSectors();
  }

  attachContactClickEvents() {
    const self = this;

    $(this.el).on('click', '[data-contact-key] a', function (event) {
      const $this = $(this);
      const contactKey = $this.closest('[data-contact-key]').data('contact-key');

      pushTrackerEvent('contactClickContact', {
        'sector': _get(self.stepLabels, self.getStepAlias(1), null),
        'location': _get(self.stepLabels, self.getStepAlias(2), null),
        'clicked_on': contactKey,
      });
    });
  }

  openSectors() {
    const queryKeys = getQuerVariables();
    if (queryKeys.length === 0 || this.stepAmount <= 0) {
      return;
    }

    let lastOpenedStep = 1;
    // Iterate through steps and find data-next-step-label values
    for (let i = 1; i < this.stepAmount; i++) {
      const queryValue = getQueryVar(this.getStepAlias(i));
      const foundButton = $(this.el).find(`.contact__step--${i} [data-step-label=${CSS.escape(queryValue)}]`);

      if (foundButton.length <= 0) {
        break;
      }

      lastOpenedStep = this.clickStepElement(foundButton, false, true);
    }

    common.smoothScrollTo(`.contact__step--${lastOpenedStep}`, 500);
  }

  clickStepElement($element, scroll = true, linkUsed = false) {
    const nextStep = parseInt($element.data('step-next'));
    const stepLabel = $element.data('step-label');
    const stepValue = $element.data('step-value') ? $element.data('step-value') : {};
    const contactInfo = $element.data('contact-info') ? $element.data('contact-info') : null;

    const currentStep = this.stepCounter;

    this.setContactInfo(contactInfo);
    this.showStep(nextStep, stepLabel, stepValue, scroll, linkUsed);
    this.setSelectionInformation();

    this.trackStepClick(currentStep, stepLabel, linkUsed);

    return nextStep;
  }

  trackStepClick(step, label, linkUsed) {
    switch (step) {
      case 1:
        pushTrackerEvent('contactSectorSelect', {
          'sector': label,
          'link_used': linkUsed,
        });

        break;

      case 2:
        pushTrackerEvent('contactLocationSelect', {
          'sector': _get(this.stepLabels, this.getStepAlias(1), null),
          'location': label,
          'link_used': linkUsed,
        });

        break;
    }
  }

  showStep(step, label, value, scroll = true, linkUsed = false) {
    this.stepData[this.stepCounter] = value;

    $(`.contact__step--${this.stepCounter} .contact__step-result input`).val(label);
    $(`.contact__step--${this.stepCounter} .contact__step-selection`).hide();

    if (step < this.stepCounter) {
      for (let i = this.stepCounter; i >= step; i--) {
        $(`.contact__step--${i} .contact__step-result`).hide();

        const stepAlias = this.getStepAlias(i);
        deleteQueryVar(stepAlias);
        delete this.stepLabels[stepAlias];
      }

      scroll = false;
    } else {
      $(`.contact__step--${this.stepCounter} .contact__step-result`).show();

      const stepAlias = this.getStepAlias(this.stepCounter);
      setQueryVar(stepAlias, label);
      this.stepLabels[stepAlias] = label;
    }

    $(`.contact__step--${step}`).show();
    $(`.contact__step--${step} .contact__step-selection`).show();
    $(`.contact__step--${step} .contact__step-result`).hide();
    $(`.contact__step--${step} .contact__step-result input`).val('');
    this.stepCounter = step;

    this.initStep(step, linkUsed);

    if (scroll) {
      common.smoothScrollTo(`.contact__step--${step}`, 500);
    }
  }

  initStep(step, linkUsed) {
    switch (step) {
      case 2:
        resetGlobalFilter();

        if (Object.prototype.hasOwnProperty.call(this.stepData, 1) === false) {
          throw new Error('Expected filter settings for step 2 in `data-step-value`.');
        }

        for (const [ key, values ] of Object.entries(this.stepData[1])) {
          if (Array.isArray(values)) {
            for (const value of values) {
              addGlobalFilter(key, value);
            }
          } else {
            addGlobalFilter(key, values);
          }
        }

        break;

      case 3:
        pushTrackerEvent('contactFormReach', {
          'sector': _get(this.stepLabels, this.getStepAlias(1), null),
          'location': _get(this.stepLabels, this.getStepAlias(2), null),
          'link_used': linkUsed,
        });

        break;
    }
  }

  setContactInfo(data) {
    if (data == null) {
      return;
    }

    const receiverField = $(this.el).find('[id$=receiver]');
    if (receiverField.length > 0) {
      let receiverAddress = null;

      if (data['receiver'] != null) {
        receiverAddress = data['receiver'];
      } else if (data['email'] != null) {
        receiverAddress = data['email'];
      } else {
        console.error('Could not find a receiver value in contact info. Possible keys: receiver, email');
      }

      if (receiverAddress != null) {
        receiverField.val(receiverAddress);
      }
    } else {
      console.error('Could not find a receiver field with id ending with `receiver`');
    }

    $(this.el).find(`[data-contact-key]`).hide();

    delete data['receiver'];

    for (const [ key, info ] of Object.entries(data)) {
      const $infoSection = $(this.el).find(`[data-contact-key=${key}]`);
      const $infoValueSection = $infoSection.find('.contact-form__data-value');

      const valueType = $infoSection.data('contact-type');
      let showDetails = false;

      switch (valueType) {
        case 'phone':
          $infoValueSection.find('a').text(info).attr('href', this.buildPhoneUrl(info));
          showDetails = info != null && info.length > 0;

          break;

        case 'email':
          $infoValueSection.find('a').text(info).attr('href', this.buildEmailUrl(info));
          showDetails = info != null && info.length > 0;

          break;

        case 'address':
          $infoValueSection.children().remove();

          if (info != null && Array.isArray(info)) {
            let counter = 0;

            for (const row of info) {
              if (counter === 0) {
                $infoValueSection.append($('<strong></strong>').text(row)).append('<br>');
              } else {
                $infoValueSection.append($('<span></span>').text(row)).append('<br>');
              }

              counter++;
            }

            showDetails = info.length > 0 && info[0].length > 0;
          }

          break;

        default:
          throw new Error(`Value type '${valueType}' of '${key}' is not supported. (data-contact-type)`);
      }

      if (showDetails) {
        $infoSection.show();
      }
    }
  }

  setSelectionInformation() {
    const locationField = $(this.el).find('[id$=location]');
    if (locationField.length > 0) {
      locationField.val(_get(this.stepLabels, this.getStepAlias(2), null));
    } else {
      console.error('Could not find a location field with id ending with `location`');
    }

    const sectorField = $(this.el).find('[id$=sector]');
    if (sectorField.length > 0) {
      sectorField.val(_get(this.stepLabels, this.getStepAlias(1), null));
    } else {
      console.error('Could not find a sector field with id ending with `sector`');
    }
  }

  getStepNumberInClasses(classes) {
    for (const currentClass of classes) {
      if (/^contact__step--(\d+)/.test(currentClass)) {
        const matches = currentClass.match(/^contact__step--(\d+)/);

        return parseInt(matches[1]);
      }
    }

    return null;
  }

  buildEmailUrl(email) {
    return `mailto:${email}`;
  }

  buildPhoneUrl(phone) {
    let santitizedPhone = phone
      .replace(/\(0\)/g, '') // Remove (0) as a reminder for leading zero (+49 (0) 2302);
      .replace(/\+/g, '00') // Replace + with double zero (+49 -> 0049)
      .replace(/[^+\d]/g, ''); // Remove any non-decimal digits

    return `tel:${santitizedPhone}`;
  }

  getStepAlias(step) {
    switch (step) {
      case 1:
        return 'sector';
      case 2:
        return 'location';
      case 3:
        return 'form';
      default:
        throw new Error(`Unable to find alias for step ${step}`);
    }
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new contactForm(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
